import React, {useState, useEffect} from 'react'
// import {useNavigate} from 'react-router-dom'
// import { CardElement, Elements, useElements, useStripe } from '@stripe/react-stripe-js';


  

function Jiujitsu() {





return (


    <div className="jiujitsu">
         
        
    <center>
         < div className='nickB'></div>
         {/* <h1>Jiu-Jitsu</h1> */}
    
        {/* <h3>Welcome to Chicago Fight Team's</h3><h3> Jiu-Jitsu Program!</h3> */}
        <p>Our program is designed for individuals of all levels who are passionate about learning and practicing Brazilian Jiu-Jitsu. Whether you are a beginner or an advanced practitioner, our world-class instructors are dedicated to helping you achieve your goals and become the best version of yourself.

At Chicago Fight Team, we believe that Jiu-Jitsu is not just a sport but a way of life. Our program is based on the principles of respect, discipline, and perseverance, which we believe are essential for achieving success on and off the mat. We take pride in creating a positive and inclusive training environment where everyone is welcome, and our members are more than just training partners, but also part of our extended family.

Our experienced instructors are passionate about sharing their knowledge and expertise with our members. They offer a structured curriculum that covers all aspects of Jiu-Jitsu, including fundamental techniques, advanced techniques, live sparring, and competition preparation. Our program also includes specialized classes, such as self-defense, women's only classes, and kids' classes, which are tailored to meet the specific needs of each group.

At Chicago Fight Team, we believe that Jiu-Jitsu is not only a great workout but also an excellent way to improve your overall health and wellbeing. Our program will help you develop strength, flexibility, endurance, and agility, while also boosting your confidence, reducing stress, and enhancing your mental focus.

We invite you to come and experience the world-class Jiu-Jitsu program at Chicago Fight Team. Whether you are looking to compete at the highest level, or just want to learn a new skill and meet new people, we have something for everyone. Sign up for a free trial today and discover the benefits of Jiu-Jitsu for yourself.</p><br></br>
<div class="video-container">
  <iframe
    class="video"
    src="https://www.youtube.com/embed/NGYfM8yBRB0?controls=0"
    title="YouTube video player"
    frameborder="0"
    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
    allowfullscreen
  ></iframe>
</div>

<br></br><p>The Chicago Fight Team's Jiu-Jitsu program has a rich history and a reputation for excellence. Founded by renowned Brazilian Jiu-Jitsu black belt and former fighter, our program has been a staple in the Chicago martial arts community for over two decades. Nicasio's passion for the art and dedication to his students have earned him numerous accolades and a reputation as one of the best Jiu-Jitsu coaches in the world.

At Chicago Fight Team, we believe that Jiu-Jitsu is not just a martial art but a way of life. Our program is rooted in the tradition and philosophy of Brazilian Jiu-Jitsu, which emphasizes respect, discipline, and perseverance. Our instructors are committed to helping students not only master the techniques of the art but also apply its principles to their daily lives.

If you're looking for a fun and challenging way to stay active, Jiu-Jitsu is an excellent option. It provides a full-body workout that improves strength, endurance, and flexibility. But the benefits of Jiu-Jitsu extend beyond physical fitness. The practice of Jiu-Jitsu promotes mental focus, stress relief, and increased self-confidence.

Our kids' Jiu-Jitsu program is an excellent way to introduce your children to the world of martial arts. Our instructors are skilled in teaching children of all ages and levels. We believe that Jiu-Jitsu is an excellent tool for instilling discipline, respect, and confidence in young children. Our program also emphasizes safety, and we take great care to ensure that our students train in a supportive and nurturing environment.

In conclusion, Chicago Fight Team's Jiu-Jitsu program offers an excellent opportunity for individuals of all ages to learn and practice Brazilian Jiu-Jitsu. Our program is designed to help you achieve your goals, whether you're looking to compete at the highest level or just looking to stay active and have fun. With our experienced instructors, world-class facilities, and welcoming community, we are confident that you will find everything you need to succeed in your Jiu-Jitsu journey at Chicago Fight Team. Sign up for a free trial today and discover the benefits of Jiu-Jitsu for yourself!</p>

 <br></br> < div className='jiujitsuT'></div>
    </center>
    
    </div>
    
    
    );
}


export default Jiujitsu;